// import * as jwt from 'jsonwebtoken';
// import * as fs from 'fs';
import decode from 'jwt-decode';
import { isMockData } from './ApiConfig';

// cannot import the following from ../../services (i.e. the module export) as we get a circular dependency error
// so import each directly

export const AUTH = 'user-auth';
export const AUTH_EXPIRES = 'user-auth-expires';
export const IDENTITY_ID = 'id';
export const IDENTITY_ORGID = 'orgid';
export const IDENTITY_NAME = 'name';
export const IDENTITY_ROLE = 'role';
export const STATE = 'state';
export const SELECTED_PORTFOLIO = 'portfolioId';
// const JWT_TOKEN = 'bb3837a0-d6e2-4e0d-a170-c5e4fcc207b4'; // TODO to go into config - copied from api for now
// const config;
// const constKey = readFileSync('./const.key');
// const publicKey = readFileSync('./public.key');

// const issuer = 'Agile corp';          // Issuer
// const subject = 'cpsolutions28@gmail.com';        // Subject
// const audience = 'http://theoctoguide.com'; // Audience

// VERIFYING OPTIONS
// const verifyOptions = {
//   issuer,
//   subject,
//   audience,
//   expiresIn: '12h',
//   algorithm: ['RS256']
// };

let mockSessionInvalidatedFlag = false;

// login(uname, pwd) {
//   return this.http
//     .request(this.config.method, this.config.uri, {body: {username: uname, password: pwd}})
//     .pipe(
//       map((user) => {
//         // login successful if there's a jwt token in the response
//         if (user) {
//           // store user details and jwt token in local storage to keep user logged in between page refreshes
//           // localStorage.setItem('currentUser', JSON.stringify(user));
//           this.setAuth(JSON.stringify(user));
//         }
//         return user;
//       }),
//     );
// }

// isLoggedIn() {
//   return this.loggedIn.asObservable();
// }

// logout() {
//   this.invalidateSession();
//   this.loggedIn.next(false);
// }

export const isAuthenticated = () => {
    if (isMockData() && !mockSessionInvalidatedFlag) {
        console.log('USING MOCK DATA - will always authenticate');
        return true;
    }
    const userAuth = localStorage.getItem(AUTH);
    if (userAuth && !isTokenExpired(userAuth)) {
        console.log('TOKEN EXPIRED = '.concat(isTokenExpired(userAuth)));
        return true;
    }
    return false;
};

// getCustomerNumber() {
//   if (this.isAuthenticated()) {
//     const auth = JSON.parse(localStorage.getItem(this.AUTH));
//     return auth.id;
//   }
//   return 0; // TODO should return null ???
// }

export const setStorageItem = (item, value) => {
    if (item && value) {
        localStorage.setItem(item, value);
    }
};

export const getStorageItem = (item) => {
    if (item) {
        return localStorage.getItem(item);
    }
    return undefined;
};

export const removeStorageItem = (item) => {
    if (item) {
        localStorage.removeItem(item);
    }
};

export const getAuth = () => {
    return getStorageItem(AUTH);
};

/* Example response
{
    "loginResponse": {
        "tokens": [
            {
                "type": "header",
                "name": "Authorization",
                "value": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVC... jwt keeps going here",
                "expires": "Tue Dec 31 2019 19:33:33 GMT+1100"
            }
        ],
        "lastLoginTime": "unknown",
        "tokenIdleTime": "unknown"
    }
}
*/
export const setAuth = (auth) => {
    mockSessionInvalidatedFlag = false;
    if (auth?.loginResponse?.tokens[0]?.value) {
        const jwt = auth.loginResponse.tokens[0].value;
        setStorageItem(AUTH, jwt);
    }
    if (auth?.loginResponse?.tokens[0]?.expires) {
        const expires = auth.loginResponse.tokens[0].expires;
        setStorageItem(AUTH_EXPIRES, expires);
    }
};

export const setIdentity = (identity) => {
    setStorageItem(IDENTITY_ROLE, identity?.role || '');
    setStorageItem(IDENTITY_ID, identity?.id || '');
    setStorageItem(IDENTITY_ORGID, identity?.orgid || '');
    setStorageItem(IDENTITY_NAME, identity?.name || '');
};

export const getIdentityRole = () => {
    return getStorageItem(IDENTITY_ROLE);
};

export const getIdentityId = () => {
    return getStorageItem(IDENTITY_ID);
};

export const getIdentityOrgId = () => {
    return getStorageItem(IDENTITY_ORGID);
};

export const getIdentityName = () => {
    return getStorageItem(IDENTITY_NAME);
};

export const getSelectedPortfolio = () => {
    return getStorageItem(SELECTED_PORTFOLIO);
};

export const invalidateSession = async () => {
    removeStorageItem(STATE);
    removeStorageItem(AUTH);
    removeStorageItem(IDENTITY_ROLE);
    removeStorageItem(IDENTITY_ID);
    removeStorageItem(IDENTITY_ORGID);
    removeStorageItem(IDENTITY_NAME);
    removeStorageItem(SELECTED_PORTFOLIO);
    console.log(localStorage);
    mockSessionInvalidatedFlag = true;
    return;
};

// generateAnonymousJWT() {
//   const payload = {
//     id: '999999999',
//     name: 'anonymous',
//     roles: 'guest',
//     admin: false,
//   };

//   return '';
//   // const token = jwt.sign(payload, this.constKey, this.signOptions);
//   // console.log("Token :" + token);
//   // return token;
// }

// export const tokenExpired = (token) => {
//   var decodedToken = decode(token, { complete: true });
//   var dateNow = new Date().getTime();

//   if (decodedToken.exp < dateNow) {
//     return true;
//   }
//   return false;
// }

export const isTokenExpired = (token) => {
    try {
        // console.log('Checking token is expired for token - '.concat(token))
        const decoded = decode(token);
        if (decoded?.exp < Date.now() / 1000) {
            // Checking if token is expired.
            return true;
        } else {
            return false;
        }
    } catch (err) {
        console.log('expired check failed due to the error - '.concat(err));
        return false;
    }
};

// the id is returned from post requests - extract the id to put back into the payload
export const extractTokenId = (token) => {
    try {
        const decoded = decode(token);
        if (decoded?.id?.id) {
            return decoded.id.id;
        }
    } catch (err) {
        console.log('getting the token id failed due to the error - '.concat(err));
        return '';
    }
};

export const isSuperUser = () => {
    return getIdentityRole() === 'royalty';
};

export const isAdmin = () => {
    return getIdentityRole() === 'gold';
};

export const isOrg = () => {
    return getIdentityId() === getIdentityOrgId();
};

export const getRoleName = () => {
    if (isSuperUser()) {
        return 'Super user';
    } else if (isAdmin()) {
        return 'Administrator';
    } else if (isOrg()) {
        return 'Organisation';
    } else {
        return 'Logged in user';
    }
};

function _pk(s) {
    const p = (Math.random().toString(16) + '000000000').substr(2, 8);
    return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
}

/*
generate a unique record uid
 */
export const generateGuid = () => {
    return (_pk(false) + _pk(true) + _pk(true) + new Date().toISOString().slice(0, 10)).replace(/-/g, '');
};

export const getBasicAuthorizationHeader = (username, password) => {
    if (username && password) {
        const header = 'Basic '.concat(Buffer.from(username.concat(':').concat(password)).toString('base64'));
        return { Authorization: header };
    }
    return null;
};



// WEBPACK FOOTER //
// ./services/Authentication.js